import type { Vec2, Vec3 } from '../geo/types';

export function layoutToWorld(p: Vec2, height: number): Vec3 {
  return [p[0], height, -p[1]];
}

export function worldToLayout(v: Vec3): Vec2 {
  return [v[0], -v[2]];
}

export function directionFromHeading(heading: number): Vec2 {
  return [Math.cos(heading), Math.sin(heading)];
}
